<ng-container>
  <button class="task-container task-button font-20"
          [ngStyle]="{'background-image':'url(' + taskSelect!.buttonImage + ')'}"
          (mouseover)="onMouseOver()"
          (mouseleave)="onMouseLeave()"
          (click)="onTaskClick()">
    <ng-container *ngIf="!taskSelect!.showPassageTitle">
      <p class="secondary-task-type task-btn-passage-title">{{ taskSelect!.secondaryTaskType }}</p>
      <p class="secondary-task-name task-btn-passage-title">{{ taskSelect!.secondaryTaskName }}</p>
    </ng-container>
    <p *ngIf="taskSelect!.showPassageTitle" class="task-btn-passage-title font-passage-title">{{ taskSelect!.passageTitle | formatString: 25 }}</p>
    <div><img [src]="taskSelect!.icon" alt="task background" /></div>
    <div class="subtask-score-wrapper" [ngClass]="{ 'secondary' : !taskSelect!.showPassageTitle }">
    @for (scoreBox of scoreBoxes; track scoreBox.id) {
      <p class="font-18 subtask-btn-scorebox" [ngStyle]="{'background-image':'url(' + scoreBox.background + ')'}">
        {{ scoreBox.score > 0 ? scoreBox.score + '%' : '' }}
      </p>
    }
    </div>
  </button>
</ng-container>
